import React from "react";
import clsx from "clsx";

type Props = {
  verticalCenter?: boolean;
  /**
   * If layout is block, it will span the entire width of the screen
   */
  block?: boolean;
};

const Layout: React.FC<Props> = ({ children, block }) => {
  const classes = {
    "flex justify-center m-auto p-2": true,
    "md:w-1/2 lg:w-1/3 xl:w-1/4": !block,
    "w-full ": block,
  };
  return (
    <div className={clsx(classes)}>
      <div className="w-full">
        {typeof children === "function" ? children() : children}
      </div>
    </div>
  );
};

export default Layout;
